/**
 * Copyright IBM Corp. 2022, 2026
 */

import * as React from 'react'

export default function PlayIcon(): React.ReactElement {
	return (
		<svg
			width="96"
			height="96"
			viewBox="0 0 96 96"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="48" cy="48" r="48" fill="#fff" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="m63.254 46.653-22.75-14.4a1.647 1.647 0 0 0-1.657-.057c-.522.28-.847.82-.847 1.405V62.4c0 .584.325 1.123.847 1.403a1.639 1.639 0 0 0 1.657-.057l22.75-14.4c.465-.294.746-.802.746-1.346 0-.545-.281-1.052-.746-1.347Z"
				fill="#fff"
				stroke="#000"
				strokeWidth="2"
			/>
		</svg>
	)
}
